module.exports = __webpack_public_path__ + "static/img/kayi-logo-white.05eaa33.png";


//////////////////
// WEBPACK FOOTER
// ./packages/assets/kayi-logo-white.png
// module id = jacJ
// module chunks = 0